import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import {
  DualPaneLayout, LeftPane, LeftPaneHeader, RightPane
} from '../../components/DualPaneLayout';

const Partner: React.FC = () => {
  const location = useLocation();
  return <>
    <DualPaneLayout>
      <LeftPane>
        <LeftPaneHeader title='Partner' />
        <Link to='academy' title='Academy'>
          <div className={`w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap ${location.pathname.endsWith('academy') ? 'bg-selected' : ''}`}>
            Academy
          </div>
        </Link>
        <Link to='accounts' title='Accounts'>
          <div className={`w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap ${location.pathname.endsWith('accounts') ? 'bg-selected' : ''}`}>
            Accounts
          </div>
        </Link>
        <Link to='datasheets' title='DataSheets'>
          <div className={`w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap ${location.pathname.endsWith('datasheets') ? 'bg-selected' : ''}`}>
          DataSheets
          </div>
        </Link>
        {/* <Link to='accounts' title='Accounts'>
          <div className={'w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap'}>
            Quotes
          </div>
        </Link> */}
        <Link to='links' title='Links'>
          <div className={`w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap ${location.pathname.endsWith('links') ? 'bg-selected' : ''}`}>
            Links
          </div>
        </Link>
        <Link to='marketing-hub' title='Marketing Hub'>
          <div className={`w-full rounded-md p-2 hover:bg-hover overflow-hidden overflow-ellipsis whitespace-nowrap ${location.pathname.endsWith('marketing-hub') ? 'bg-selected' : ''}`}>
            Marketing Hub
          </div>
        </Link>
      </LeftPane>
      <RightPane>
        <Outlet />
      </RightPane>
    </DualPaneLayout>
  </>;
};

export default Partner;
